import {
  JobTypes,
  InventoryTypes,
  ServiceCharges,
  ServiceProducts
} from "../../common/constants";
import { ProductItem } from "../../common/interfaces";

export function calculateCharge(
  OperatingCompanyCode: string,
  jobType: string,
  inventoryType: string,
  prodref: string
): ProductItem {
  
  let serviceChargeRef = "";
  switch (jobType) {
    case JobTypes.INSPECTION:
      
      serviceChargeRef = calculateInspectionCharge(inventoryType, prodref);
      break;
    case JobTypes.SERVICE:
      
      serviceChargeRef = calculateServiceCharge(inventoryType, prodref);
      break;
    default:
      serviceChargeRef = "";
  }
  const serviceCharge: ProductItem = {
    OperatingCompanyCode,
    ProductItemId: serviceChargeRef,
    Description: ""
  };
  return serviceCharge;
}

function calculateServiceCharge(
  inventoryType: string,
  prodref: string
): string {
  switch (inventoryType) {
    case InventoryTypes.VEHICLE_LIFT:
      return ServiceCharges.VEHICLE_LIFT_SERVICE_CHARGE;
    case InventoryTypes.CELLAR_LIFT:
      if (
        prodref === ServiceProducts.PRODUCT_MEZZ_LIFT_250 ||
        prodref === ServiceProducts.PRODUCT_CELLAR_LIFT
      ) {
        return ServiceCharges.MEZZ_LIFT_250_SERVICE_CHARGE;
      } else if (prodref === ServiceProducts.PRODUCT_MEZZ_LIFT_500) {
        return ServiceCharges.MEZZ_LIFT_500_SERVICE_CHARGE;
      } else if (prodref === ServiceProducts.PRODUCT_STILLAGE_TRUCK) {
        return ServiceCharges.FORKLIFT_SERVICE_CHARGE;
      }
      break;
  }
  return "";
}

function calculateInspectionCharge(
  inventoryType: string,
  prodref: string
): string {
  switch (inventoryType) {
    case InventoryTypes.VEHICLE_LIFT:
      return ServiceCharges.VEHICLE_LIFT_INSPECTION_CHARGE;
    case InventoryTypes.CELLAR_LIFT:
      if (
        prodref === ServiceProducts.PRODUCT_MEZZ_LIFT_250 ||
        prodref === ServiceProducts.PRODUCT_CELLAR_LIFT
      ) {
        return ServiceCharges.MEZZ_LIFT_250_INSPECTION_CHARGE;
      } else if (prodref === ServiceProducts.PRODUCT_MEZZ_LIFT_500) {
        return ServiceCharges.MEZZ_LIFT_500_INSPECTION_CHARGE;
      }
    case InventoryTypes.LOWERING_SYSTEM:
      return "";
  }
  return "";
}
